import { render, staticRenderFns } from "./BiobankMain.vue?vue&type=template&id=61fef7a2&scoped=true&"
import script from "./BiobankMain.vue?vue&type=script&lang=js&"
export * from "./BiobankMain.vue?vue&type=script&lang=js&"
import style0 from "./BiobankMain.vue?vue&type=style&index=0&id=61fef7a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fef7a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
